export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10852.52fc79cf.jpg";